<template>
  <ComponentLayout
    id="refine"
    fluid_main_container
    main_color="var(--color-main-green)"
    style="max-width: 100vw;">
    <template #breadcrumbs>
      <slot name="bread"/>
    </template>
    <template #main_content>
      <div
        class="content-card main__green pr-8 mr-5 mt-4">
        <div
          class="flex flex-between">
          <div>
            <slot name="step"/>
            <div class="h1-headline text-left">
              {{ title ? title : $t('Catalog.RefinePurchase') }}
            </div>
            <div
              v-if="subtitle"
              class="mt-4 h6-text text-left">
              {{ typeof subtitle == 'string'? subtitle : $t('Catalog.SpecifyQuantity') }}
            </div>
          </div>
          <div class="align-top text-right">
            <slot name="next_step"/>
          </div>
        </div>
        <div
          id="refine-table-container"
          class="mt-6">
          <slot name="table"/>
        </div>
      </div>
    </template>
    <template #footer>
      <slot name="footer"/>
    </template>
  </ComponentLayout>
</template>

<script>
import ComponentLayout from 'pages/templates/ComponentLayout.vue'

export default {
  name: 'refineComponent',
  props: {
    element: Object,
    title: String,
    subtitle: [String, Boolean]
  },
  components: {
    ComponentLayout
  }
}
</script>
<style lang="scss" scoped>
.content-card {
  width: 100%;

  .card-title-text {
    line-height: 20px;
    font-size: 16px;
    color: var(--text-color);
    letter-spacing: -0.02em;
  }
  .clear-text-icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .resource_group {
    font-size: 12px;
    line-height: 16px;
    min-height: 20px;
    height: 20px;
  }
}
.options-item {
  min-height: 35px;
  height: 35px;
}
.footer {
  width: 100vw;
  height: 72px;
  border-top: 2px solid var(--v-secondary__green_chosen-base) !important;
  .btn {
    font-weight: 600;
    letter-spacing: 0.03em;
  }
}
.measurement {
  height: 20px;
}
</style>
